

const Map = () => <section>

<iframe
  style={{
    width: "100%",
    
    height: "40vh",
    border: "none",
  }}
  frameborder="0"
  scrolling="no"
  marginheight="0"
  marginwidth="0"
  id="gmap_canvas"
  src="https://maps.google.com/maps?width=1588&amp;height=400&amp;hl=en&amp;q=F/23,%20F/23,%20F/23%20Rojhan%20St,%20Block%205%20Clifton,%20Karachi+(TIS%20School%20)&amp;t=h&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
></iframe>

<script type="text/javascript" src="https://embedmaps.com/google-maps-authorization/script.js?id=fb5ae5c96c9383927f21dbb0ac27b8784f47cba0"></script>

           </section>
export default Map